import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

export const SUPPORTED_LOCALES = ["sr", "en", "de", "hr", "sl", "it", "es", "fr", "ru", "tr"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

/**
 * i18n bootstrap. Locales live under /public/locales/<lang>/<namespace>.json
 * and are lazy-loaded per route via i18next-http-backend.
 *
 * Locale resolution order:
 * 1. authenticated user.locale (set by AuthProvider via i18n.changeLanguage)
 * 2. localStorage (LanguageDetector)
 * 3. browser navigator.language
 * 4. fallback "en"
 */
void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LOCALES as readonly string[] as string[],
    load: "languageOnly", // strip "en-US" → "en"
    ns: ["common", "auth"],
    defaultNS: "common",
    // Keys are stored FLAT with literal dots (e.g. "catalog.breadcrumb"). Disabling the
    // key separator makes every dotted key a literal lookup, so a key used both as a label
    // ("catalog.breadcrumb") and as a parent ("catalog.breadcrumb.catalog") can coexist
    // without i18next building an object at the shared path ("returned an object instead
    // of string"). Locale JSON is fully flattened to match.
    keySeparator: false,
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "bankom.locale",
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
